import React from "react";

import {
  Subscription,
  ThreeElements,
  Cancelled,
  ClassPrice,
  Custom,
} from "./TotalAmountStyle";

type TotalAmountPropsType = {
  classPrice: number;
  discountAmount: number;
  currency: string;
};

const TotalAmount = ({
  classPrice,
  discountAmount,
  currency,
}: TotalAmountPropsType) => {
  const renderCurrency = () => {
    if (currency === "usd") return "$";
    if (currency === "eur") return "€";
    if (currency === "sgd") return "S$";
    if (currency === "krw") return "₩";
    if (currency === "gbp") return "£";
    if (currency === "aud") return "A$";
    if (currency === "cad") return "C$";
    if (currency === "jpy") return "¥";
    if (currency === "vnd") return "₫";
    return "";
  };
  const ifPriceGotTooLong = (numb: number) => {
    // when price gets longer than 3 digits, add a comma
    const str = numb.toString().split(".");
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return str.join(".");
  };

  return (
    <>
      <ThreeElements>
        <Subscription>Subscription</Subscription>
        <Cancelled>Can Be Cancelled Any Time </Cancelled>
        <ClassPrice>
          {renderCurrency()} {ifPriceGotTooLong(classPrice)}
        </ClassPrice>
      </ThreeElements>

      {discountAmount !== 0 ? (
        <ThreeElements>
          <Subscription>Discount</Subscription>
          <ClassPrice>
            - {renderCurrency()} {ifPriceGotTooLong(discountAmount)}
          </ClassPrice>
        </ThreeElements>
      ) : null}

      <Custom style={{ color: "black" }} />

      <ThreeElements>
        <Subscription style={{ fontWeight: "bold" }}>What You Pay</Subscription>
        <ClassPrice>
          {renderCurrency()}{" "}
          {ifPriceGotTooLong(Math.max(classPrice - discountAmount, 0))}
        </ClassPrice>
      </ThreeElements>
    </>
  );
};
export default TotalAmount;
